import React from 'react'
import { getTranslation } from '../translations'

function SectionHeader({ title, subtitle }) {
  return (
    <div className="mb-2">
      <div className="bg-[#134225] text-white font-extrabold px-3 py-2 uppercase tracking-wide text-sm">{title}</div>
      {subtitle ? (
        <div className="text-[12px] italic text-[#334c3e] px-2 py-1">{subtitle}</div>
      ) : null}
    </div>
  )
}

function IndicatorRow({ indicator, lowEffect, highEffect, t }) {
  return (
    <>
      <tr className="odd:bg-white even:bg-gray-50 text-sm">
        <td className="px-3 py-3 border border-[#e4ebe7] font-semibold" rowSpan={2}>{indicator}</td>
        <td className="px-3 py-3 border border-[#e4ebe7] font-semibold text-red-600">{t.low}</td>
        <td className="px-3 py-3 border border-[#e4ebe7]">{lowEffect}</td>
      </tr>
      <tr className="odd:bg-white even:bg-gray-50 text-sm">
        <td className="px-3 py-3 border border-[#e4ebe7] font-semibold text-yellow-600">{t.high}</td>
        <td className="px-3 py-3 border border-[#e4ebe7]">{highEffect}</td>
      </tr>
    </>
  )
}

function NutrientBlockRow({ nutrient, blocks }) {
  return (
    <tr className="odd:bg-white even:bg-gray-50 text-sm">
      <td className="px-3 py-3 border border-[#e4ebe7] font-semibold">{nutrient}</td>
      <td className="px-3 py-3 border border-[#e4ebe7]">{blocks}</td>
    </tr>
  )
}

export default function DerivedInsights({
  title,
  subtitle,
  indicators = [],
  blockingTitle,
  blockingData = [],
  language = 'english',
}) {
  const t = getTranslation(language)
  const sectionTitle = title || t.section4Title
  const sectionSubtitle = subtitle || t.section4Subtitle
  const blockingSectionTitle = blockingTitle || t.blockingTitle
  
  return (
    <div className="mt-6">
      {/* Derived Insights Table */}
      <SectionHeader title={sectionTitle} subtitle={sectionSubtitle} />
      <div className="border border-[#cbd9d2] rounded-md overflow-hidden">
        <table className="w-full">
          <thead>
            <tr className="bg-[#134225] text-white text-sm">
              <th className="px-3 py-2 border border-[#d9e4dd] text-left">{t.indicator}</th>
              <th className="px-3 py-2 border border-[#d9e4dd] text-left">{t.condition}</th>
              <th className="px-3 py-2 border border-[#d9e4dd] text-left">{t.imbalanceEffect}</th>
            </tr>
          </thead>
          <tbody>
            {indicators.map((ind) => (
              <IndicatorRow 
                key={ind.indicator} 
                indicator={ind.indicator} 
                lowEffect={ind.lowEffect} 
                highEffect={ind.highEffect}
                t={t}
              />
            ))}
          </tbody>
        </table>
      </div>

      {/* Nutrient Blocking Table */}
      {blockingData.length > 0 && (
        <div className="mt-6">
          <div className="bg-[#134225] text-white font-extrabold px-3 py-2 uppercase tracking-wide text-sm">
            {blockingSectionTitle}
          </div>
          <div className="border border-[#cbd9d2] rounded-md overflow-hidden mt-2">
            <table className="w-full">
              <thead>
                <tr className="bg-[#134225] text-white text-sm">
                  <th className="px-3 py-2 border border-[#d9e4dd] text-left">{t.whenTooMuchOf}</th>
                  <th className="px-3 py-2 border border-[#d9e4dd] text-left">{t.itBlocks}</th>
                </tr>
              </thead>
              <tbody>
                {blockingData.map((item, idx) => (
                  <NutrientBlockRow key={idx} nutrient={item.nutrient} blocks={item.blocks} />
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  )
}
